const Hero = () => {
  return (
    <section className='pt-20 pb-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-top-60 before:-left-60 before:w-[700px] before:h-[700px] before:bg-gradient-radial before:from-cyan-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10 text-center'>
        <h1 className='animate text-4xl md:text-6xl font-montserrat font-bold mb-6 leading-tight'>
          Мы делаем продукты,{' '}
          <span className='bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-sky-500'>
            а не обещания
          </span>
        </h1>
        <p className='animate text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto mb-10'>
          HiSphere — небольшая команда, которая пишет и поддерживает свои приложения сама. Сейчас это связь, архивация файлов и тренировки.
        </p>
        <div className='animate flex flex-col sm:flex-row gap-4 justify-center'>
          <a
            href='#solutions'
            className='bg-gradient-to-br from-cyan-400 to-sky-500 text-[#0b1e3d] font-bold py-3 px-8 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 hover:from-sky-500 hover:to-cyan-400 transition-all duration-300'
          >
            Смотреть продукты
          </a>
          <a
            href='/contact'
            className='glass-card font-bold py-3 px-8 rounded-xl text-gray-900 dark:text-white hover:-translate-y-1 transition-all duration-300'
          >
            Связаться с нами
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
